import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  icon: {
    cursor: "pointer",
  },
}));

export default styles;
